const PercentageBar = require('./PercentageBar');

module.exports = PercentageBar;
